// LearningSubTabs.js - Contextual sub-tab strip rendered under the header bar
// while the learner is inside Learning/Video/PWO (Analytics, Engagement,
// Tests, Homework Help, Chapters/Modules, AP Exam Prep when flagged).
import React from "react";
import { Pressable, ScrollView, StyleSheet, Text, View } from "react-native";

import { HEADER } from "./headerTheme";

const styles = StyleSheet.create({
  scroll: {
    flexGrow: 0,
    backgroundColor: HEADER.brandDeep,
  },
  row: {
    height: HEADER.subBarHeight,
    backgroundColor: HEADER.brandDeep,
    flexDirection: "row",
    alignItems: "stretch",
    borderTopWidth: 1,
    borderTopColor: "rgba(0,0,0,0.12)",
  },
  tab: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
  },
  tabFirst: {
    paddingLeft: 0,
  },
  label: {
    fontSize: 13.5,
    fontWeight: "500",
    color: HEADER.onBrandInactive,
  },
  labelActive: {
    color: HEADER.onBrand,
    fontWeight: "600",
  },
  underline: {
    position: "absolute",
    left: 10,
    right: 10,
    bottom: 0,
    height: 3,
    backgroundColor: HEADER.onBrand,
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
  },
  underlineFirst: {
    left: 0,
  },
});

const LearningSubTabs = ({
  items = [],
  activeKey,
  onSelect,
  t = (s) => s,
  testID,
  paddingHorizontal = 16,
}) => (
  <ScrollView
    horizontal
    showsHorizontalScrollIndicator={false}
    style={styles.scroll}
    testID={testID}
  >
    <View
      style={[styles.row, { paddingHorizontal }]}
      accessible
      accessibilityRole="tablist"
    >
      {items.map((item, index) => {
        const selected = item.key === activeKey;
        const isFirst = index === 0;

        return (
          <Pressable
            key={item.key}
            onPress={() => onSelect(item.key)}
            style={[styles.tab, isFirst && styles.tabFirst]}
            accessibilityRole="tab"
            accessibilityState={{ selected }}
            testID={`subtab-${item.key}`}
          >
            <Text style={[styles.label, selected && styles.labelActive]}>{item.label}</Text>
            {selected ? (
              <View
                style={[styles.underline, isFirst && styles.underlineFirst]}
                testID={`subtab-${item.key}-underline`}
              />
            ) : null}
          </Pressable>
        );
      })}
    </View>
  </ScrollView>
);

export default LearningSubTabs;
